<template>
  <transition name="slide-up">
    <div v-if="xp.visible" class="xp-alert" :class="xp.disperse">
      <div class="alert">
        <base-svg svg="sparkles" height="1.1rem" />
        <span class="message">
          <span class="ele cx">{{ xp.count }}</span>
          <span class="ele xp">XP</span>
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    data() {
      return {
        xp: {
          visible: false,
          disperse: '',
          count: 0,
        }
      }
    },

    mounted () {
      this.EventBus.$on('tab:xp', (count) => {
        this.xp.visible = true;
        this.xp.count = count;
        this.xp.disperse = `disperse`;

        let i = Math.ceil(Math.random() * 3);

        let iTimeIn = 400;
        let iTimeOut = 1000; // * 1000 (to stop & edit)
        let iTimeClear = 200;

        setTimeout(() => {
          this.xp.disperse= `disperse in pattern-${i}-in`;
        }, iTimeIn);

        setTimeout(() => {
          this.xp.disperse = `disperse out pattern-${i}-out`;
        }, iTimeIn + iTimeOut);

        setTimeout(() => {
          this.xp.visible = false;
          this.xp.disperse = false;
          this.xp.count = 0;
        }, iTimeIn + iTimeOut + iTimeClear);
      });
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .xp-alert {
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom) + 4.5rem);
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: max-content;
    max-width: 900px;
    padding: .5rem 1rem .5rem 1rem;
    // border-top-left-radius: 15px;
    // border-top-right-radius: 15px;
    border-radius: 1em;
    // background: radial-gradient(circle at bottom right, rgba($purple-tone-3, 1), rgba($neutral-100, 1) 70%);
    color: $purple-tone-1;
    .darkmode & {
      color: $purple-tone-1;
    }
    z-index: 250;

    // width: 120px;
    background: rgba($purple-tone-3, 0.6);
    backdrop-filter: blur(4px);
    border: 1px solid rgba($purple-tone-1, 0.2);

    &.disperse {
      transition: all 0s;
      transform: translateX(0) translateY(0);
      opacity: 0;

      &.in {
        transition: all .25s ease-in-out;
        opacity: 1;
      }
      &.out {
        transition: all .75s ease-in-out;
        opacity: 0;
      }

      &.pattern-1-in { transform: translateX(-10px) translateY(-30px); }
      &.pattern-1-out { transform: translateX(-30px) translateY(-150px); }

      &.pattern-2-in { transform: translateX(-15px) translateY(-20px); }
      &.pattern-2-out { transform: translateX(-10px) translateY(-200px); }

      &.pattern-3-in { transform: translateX(-10px) translateY(-10px); }
      &.pattern-3-out { transform: translateX(-40px) translateY(-100px); }
    }

    svg {
      fill: $purple-tone-1;

      .darkmode & {
        fill: $purple-tone-1;
      }
    }

    .alert {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      gap: 0.5rem;

      .message {
        font-size: 1.2rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        gap: 0.15em;

        .ele {
          display: block;

          &.cx {
            color: $purple-tone-1;
            text-shadow: 0px 0px 5px rgba($purple-tone-1, 0.2);

          }

          &.up {
            font-size: .8rem;
          }

          &.xp {
            font-size: .8rem;
            justify-content: baseline;
          }
        }

      }
    }
  }
</style>